function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import isObjectLike from 'lodash/isObjectLike';
import intlShape from 'shapes/intlShape';
var _React_PureComponent;
/**
 * Textarea component extends simple textarea
 *
 * @param {string} id - unique Textarea id
 * @param {string} [value=""] - textarea value
 * @param {(string|Object)} [className] - additional input className
 * @param {function} onChange - action that is triggered by textarea value change
 * @param {function} [onBlur] - action that is triggered when textarea has been lost focus
 */ class TextArea extends (_React_PureComponent = React.PureComponent) {
    renderPlaceholder() {
        if (!this.props.placeholder) {
            return null;
        }
        return isObjectLike(this.props.placeholder) ? this.props.intl.formatMessage(this.props.placeholder, _object_spread({}, this.props.placeholder.values)) : this.props.placeholder;
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn('input-container', this.props.classNameWrapper),
            children: /*#__PURE__*/ _jsx("textarea", _object_spread_props(_object_spread({
                id: this.props.id,
                value: this.props.value,
                className: cn('form-control', 'form-control--textarea', this.props.className)
            }, this.props.attributes), {
                placeholder: this.renderPlaceholder(),
                onChange: (event)=>this.props.onChange({
                        id: this.props.id,
                        value: event.target.value
                    }),
                onBlur: (event)=>this.props.onBlur({
                        id: this.props.id,
                        value: event.target.value
                    })
            }))
        });
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
_define_property(TextArea, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    value: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    classNameWrapper: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    placeholder: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    attributes: PropTypes.object,
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
});
_define_property(TextArea, "defaultProps", {
    value: '',
    className: '',
    attributes: {},
    onBlur: ()=>{}
});
export default injectIntl(TextArea);
